import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7af43012"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "view-type" }
const _hoisted_2 = { id: "data-type" }
const _hoisted_3 = ["value"]
const _hoisted_4 = { class: "central_query--outer" }
const _hoisted_5 = { class: "central_query--wrapper" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "label" }, "BU", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "label" }, "Brand", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "item-name" }, "Make", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "item-name" }, "Type Class", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "item-name" }, "Region", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "item-name" }, "Sub Region", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "item-name" }, "Province", -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "item-name" }, "City", -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "item-name" }, "Year", -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "item-name" }, "Q/M", -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "item-name" }, "Restricted City", -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "item-name" }, "Dealer Name(CN/EN)", -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "item-name" }, "Dealer Group(CN/EN)", -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "item-name" }, "Calculation Rule", -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "label" }, "Data View", -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "label" }, "VAN Dealer Select", -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "label" }, " ", -1))
const _hoisted_23 = /*#__PURE__*/_createTextVNode("Reset")
const _hoisted_24 = { class: "function-btn" }
const _hoisted_25 = /*#__PURE__*/_createTextVNode("Download")
const _hoisted_26 = /*#__PURE__*/_createTextVNode("Search")
const _hoisted_27 = { class: "central_table--outer" }
const _hoisted_28 = { class: "central_table" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Breadcrumb = _resolveComponent("Breadcrumb")!
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_space = _resolveComponent("a-space")!
  const _component_a_date_picker = _resolveComponent("a-date-picker")!
  const _component_a_tree_select = _resolveComponent("a-tree-select")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_DM = _resolveComponent("DM")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Breadcrumb, { dataSource: [] }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("ul", _hoisted_2, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.viewTypes, (item) => {
          return (_openBlock(), _createElementBlock("li", {
            value: item.id,
            key: item.id,
            class: _normalizeClass({ activate: _ctx.selectedViewType === item.id }),
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.selectViewType2 && _ctx.selectViewType2(...args)))
          }, _toDisplayString(item.title), 11, _hoisted_3))
        }), 128))
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_a_space, {
          class: "central_query--form",
          direction: "vertical",
          size: _ctx.spaceSize
        }, {
          default: _withCtx(() => [
            _hoisted_6,
            _createVNode(_component_a_select, {
              value: _ctx.bu,
              "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.bu) = $event)),
              placeholder: "Please select",
              class: "sel-inp-size",
              mode: "multiple"
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.buList, (item) => {
                  return (_openBlock(), _createBlock(_component_a_select_option, {
                    value: item.nameEn,
                    key: item.nameEn,
                    title: item.nameEn
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(item.nameEn), 1)
                    ]),
                    _: 2
                  }, 1032, ["value", "title"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["value"])
          ]),
          _: 1
        }, 8, ["size"]),
        _createVNode(_component_a_space, {
          class: "central_query--form",
          direction: "vertical",
          size: _ctx.spaceSize
        }, {
          default: _withCtx(() => [
            _hoisted_7,
            _createVNode(_component_a_select, {
              class: "sel-inp-size",
              allowClear: "",
              value: _ctx.brand,
              "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.brand) = $event)),
              placeholder: "Please select"
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.brandList, (item) => {
                  return (_openBlock(), _createBlock(_component_a_select_option, {
                    key: item.brandNameEn,
                    value: item.brandNameEn
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(item.brandNameEn), 1)
                    ]),
                    _: 2
                  }, 1032, ["value"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["value"])
          ]),
          _: 1
        }, 8, ["size"]),
        _createVNode(_component_a_space, {
          class: "central_query--form",
          direction: "vertical",
          size: _ctx.spaceSize
        }, {
          default: _withCtx(() => [
            _hoisted_8,
            _createVNode(_component_a_select, {
              value: _ctx.make,
              "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.make) = $event)),
              placeholder: "Please select",
              class: "sel-inp-size"
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.makeList, (item) => {
                  return (_openBlock(), _createBlock(_component_a_select_option, {
                    value: item,
                    key: item,
                    title: item
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(item), 1)
                    ]),
                    _: 2
                  }, 1032, ["value", "title"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["value"])
          ]),
          _: 1
        }, 8, ["size"]),
        _createVNode(_component_a_space, {
          class: "central_query--form",
          direction: "vertical",
          size: _ctx.spaceSize
        }, {
          default: _withCtx(() => [
            _hoisted_9,
            _createVNode(_component_a_select, {
              "allow-clear": "",
              value: _ctx.typeClass,
              "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.typeClass) = $event)),
              placeholder: "Please select",
              class: "sel-inp-size"
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.typeClassList, (item, index) => {
                  return (_openBlock(), _createBlock(_component_a_select_option, {
                    value: item,
                    key: index
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(item), 1)
                    ]),
                    _: 2
                  }, 1032, ["value"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["value"])
          ]),
          _: 1
        }, 8, ["size"]),
        _createVNode(_component_a_space, {
          class: "central_query--form",
          direction: "vertical",
          size: _ctx.spaceSize
        }, {
          default: _withCtx(() => [
            _hoisted_10,
            _createVNode(_component_a_select, {
              value: _ctx.region,
              "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.region) = $event)),
              placeholder: "Please select",
              "allow-clear": "",
              class: "sel-inp-size"
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.regionList, (item) => {
                  return (_openBlock(), _createBlock(_component_a_select_option, {
                    value: item.regionEn,
                    key: item.regionEn,
                    title: item.regionEn
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(item.regionEn), 1)
                    ]),
                    _: 2
                  }, 1032, ["value", "title"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["value"])
          ]),
          _: 1
        }, 8, ["size"]),
        _createVNode(_component_a_space, {
          class: "central_query--form",
          direction: "vertical",
          size: _ctx.spaceSize
        }, {
          default: _withCtx(() => [
            _hoisted_11,
            _createVNode(_component_a_select, {
              disabled: !_ctx.region,
              value: _ctx.subRegion,
              "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.subRegion) = $event)),
              placeholder: "Please select",
              "allow-clear": "",
              class: "sel-inp-size"
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.subRegionList, (item) => {
                  return (_openBlock(), _createBlock(_component_a_select_option, {
                    value: item.regionEn,
                    key: item.regionEn,
                    title: item.regionEn
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(item.regionEn), 1)
                    ]),
                    _: 2
                  }, 1032, ["value", "title"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["disabled", "value"])
          ]),
          _: 1
        }, 8, ["size"]),
        _createVNode(_component_a_space, {
          class: "central_query--form",
          direction: "vertical",
          size: _ctx.spaceSize
        }, {
          default: _withCtx(() => [
            _hoisted_12,
            _createVNode(_component_a_select, {
              value: _ctx.province,
              "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.province) = $event)),
              placeholder: "Please select",
              "allow-clear": "",
              class: "sel-inp-size"
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.provinceList, (item) => {
                  return (_openBlock(), _createBlock(_component_a_select_option, {
                    value: item.provinceEn,
                    key: item.provinceEn,
                    title: item.provinceEn
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(item.provinceEn), 1)
                    ]),
                    _: 2
                  }, 1032, ["value", "title"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["value"])
          ]),
          _: 1
        }, 8, ["size"]),
        _createVNode(_component_a_space, {
          class: "central_query--form",
          direction: "vertical",
          size: _ctx.spaceSize
        }, {
          default: _withCtx(() => [
            _hoisted_13,
            _createVNode(_component_a_select, {
              value: _ctx.city,
              "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.city) = $event)),
              placeholder: "Please select",
              "allow-clear": "",
              class: "sel-inp-size",
              disabled: !_ctx.province
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.cityList, (item) => {
                  return (_openBlock(), _createBlock(_component_a_select_option, {
                    value: item.cityEn,
                    key: item.cityEn,
                    title: item.cityEn
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(item.cityEn), 1)
                    ]),
                    _: 2
                  }, 1032, ["value", "title"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["value", "disabled"])
          ]),
          _: 1
        }, 8, ["size"]),
        _createVNode(_component_a_space, {
          class: "central_query--form",
          direction: "vertical",
          size: _ctx.spaceSize
        }, {
          default: _withCtx(() => [
            _hoisted_14,
            _createVNode(_component_a_date_picker, {
              class: "sel-inp-size",
              mode: "year",
              valueFormat: "YYYY",
              format: "YYYY",
              placeholder: "Please select",
              open: _ctx.openYear,
              onOpenChange: _ctx.handlerOpenYearChange,
              value: _ctx.year,
              "onUpdate:value": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.year) = $event)),
              onPanelChange: _ctx.handlerPanelYearChange
            }, null, 8, ["open", "onOpenChange", "value", "onPanelChange"])
          ]),
          _: 1
        }, 8, ["size"]),
        _createVNode(_component_a_space, {
          class: "central_query--form",
          direction: "vertical",
          size: _ctx.spaceSize
        }, {
          default: _withCtx(() => [
            _hoisted_15,
            _createVNode(_component_a_tree_select, {
              class: "sel-inp-size",
              style: {"width":"100%"},
              maxTagCount: 1,
              value: _ctx.qm,
              "onUpdate:value": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.qm) = $event)),
              "tree-data": _ctx.qmOptions,
              "allow-clear": "",
              disabled: !_ctx.year,
              "show-checked-strategy": _ctx.SHOW_PARENT,
              placeholder: "Please select"
            }, null, 8, ["value", "tree-data", "disabled", "show-checked-strategy"])
          ]),
          _: 1
        }, 8, ["size"]),
        _createVNode(_component_a_space, {
          class: "central_query--form",
          direction: "vertical",
          size: _ctx.spaceSize
        }, {
          default: _withCtx(() => [
            _hoisted_16,
            _createVNode(_component_a_select, {
              value: _ctx.restrictedCity,
              "onUpdate:value": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.restrictedCity) = $event)),
              placeholder: "Please select",
              "allow-clear": "",
              class: "sel-inp-size"
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.restrictedCityType, (item) => {
                  return (_openBlock(), _createBlock(_component_a_select_option, {
                    value: item,
                    key: item,
                    title: item
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(item), 1)
                    ]),
                    _: 2
                  }, 1032, ["value", "title"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["value"])
          ]),
          _: 1
        }, 8, ["size"]),
        _createVNode(_component_a_space, {
          class: "central_query--form",
          direction: "vertical",
          size: _ctx.spaceSize
        }, {
          default: _withCtx(() => [
            _hoisted_17,
            _createVNode(_component_a_input, {
              value: _ctx.dealerName,
              "onUpdate:value": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.dealerName) = $event)),
              placeholder: "Please input"
            }, null, 8, ["value"])
          ]),
          _: 1
        }, 8, ["size"]),
        _createVNode(_component_a_space, {
          class: "central_query--form",
          direction: "vertical",
          size: _ctx.spaceSize
        }, {
          default: _withCtx(() => [
            _hoisted_18,
            _createVNode(_component_a_input, {
              value: _ctx.dealerGroup,
              "onUpdate:value": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.dealerGroup) = $event)),
              placeholder: "Please input"
            }, null, 8, ["value"])
          ]),
          _: 1
        }, 8, ["size"]),
        _createVNode(_component_a_space, {
          class: "central_query--form",
          direction: "vertical",
          size: _ctx.spaceSize
        }, {
          default: _withCtx(() => [
            _hoisted_19,
            _createVNode(_component_a_select, {
              value: _ctx.calculationRule,
              "onUpdate:value": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.calculationRule) = $event)),
              placeholder: "Please select",
              "allow-clear": "",
              class: "sel-inp-size"
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.calculationRuleType, (item) => {
                  return (_openBlock(), _createBlock(_component_a_select_option, {
                    value: item.id,
                    key: item.id,
                    title: item.name
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(item.name), 1)
                    ]),
                    _: 2
                  }, 1032, ["value", "title"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["value"])
          ]),
          _: 1
        }, 8, ["size"]),
        (_ctx.selectedViewType === 2)
          ? (_openBlock(), _createBlock(_component_a_space, {
              key: 0,
              class: "central_query--form",
              direction: "vertical",
              size: _ctx.spaceSize
            }, {
              default: _withCtx(() => [
                _hoisted_20,
                _createVNode(_component_a_select, {
                  value: _ctx.dataView,
                  "onUpdate:value": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.dataView) = $event)),
                  placeholder: "Please select",
                  class: "sel-inp-size",
                  onChange: _ctx.handleDataViewChange
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dataViewList, (item) => {
                      return (_openBlock(), _createBlock(_component_a_select_option, {
                        value: item.value,
                        key: item.value
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(item.title), 1)
                        ]),
                        _: 2
                      }, 1032, ["value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["value", "onChange"])
              ]),
              _: 1
            }, 8, ["size"]))
          : _createCommentVNode("", true),
        (_ctx.isVAN)
          ? (_openBlock(), _createBlock(_component_a_space, {
              key: 1,
              class: "central_query--form",
              direction: "vertical",
              size: _ctx.spaceSize
            }, {
              default: _withCtx(() => [
                _hoisted_21,
                _createVNode(_component_a_select, {
                  value: _ctx.dealerCodeType,
                  "onUpdate:value": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.dealerCodeType) = $event)),
                  placeholder: "Please select",
                  class: "sel-inp-size"
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dealerCodeTypeList, (item) => {
                      return (_openBlock(), _createBlock(_component_a_select_option, {
                        value: item.value,
                        key: item.value
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(item.title), 1)
                        ]),
                        _: 2
                      }, 1032, ["value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["value"])
              ]),
              _: 1
            }, 8, ["size"]))
          : _createCommentVNode("", true),
        _createVNode(_component_a_space, null, {
          default: _withCtx(() => [
            _createVNode(_component_a_space, {
              direction: "vertical",
              size: _ctx.spaceSize
            }, {
              default: _withCtx(() => [
                _hoisted_22,
                _createVNode(_component_a_button, { onClick: _ctx.reset }, {
                  default: _withCtx(() => [
                    _hoisted_23
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ]),
              _: 1
            }, 8, ["size"])
          ]),
          _: 1
        }),
        _createElementVNode("div", _hoisted_24, [
          _createVNode(_component_a_button, { onClick: _ctx.download }, {
            default: _withCtx(() => [
              _hoisted_25
            ]),
            _: 1
          }, 8, ["onClick"]),
          _createVNode(_component_a_button, {
            type: "primary",
            onClick: _ctx.search
          }, {
            default: _withCtx(() => [
              _hoisted_26
            ]),
            _: 1
          }, 8, ["onClick"])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_27, [
      _createElementVNode("div", _hoisted_28, [
        _createVNode(_component_a_table, {
          id: "region-table",
          dataSource: _ctx.dataSource,
          columns: _ctx.columns,
          pagination: false,
          scroll: { x: _ctx.tableWidth, y: _ctx.colHeight },
          rowClassName: _ctx.genRowClassName
        }, null, 8, ["dataSource", "columns", "scroll", "rowClassName"])
      ])
    ]),
    _createVNode(_component_DM, {
      downloadVisible: _ctx.downloadTypeVisible,
      downloadTableData: _ctx.downloadTableData,
      language: "EN",
      onCloseAction: _ctx.closeDownloadTypeModal,
      onDownloadAction: _ctx.handleOk
    }, null, 8, ["downloadVisible", "downloadTableData", "onCloseAction", "onDownloadAction"])
  ], 64))
}